/**
 *
 * All the images are imported here to export them in the different components where they are needed
 *
 **/
import notUser from './img/notUser.png';
import notUser2 from './img/notUser2.jpg';
import search2 from './img/search2.svg';
import messager2 from './img/messager2.svg';
import settingMain from './img/settingMain.svg';
import mail from './img/mail.svg';
import web from './img/web.svg';
import pencilMain from './img/pencilMain.svg';
import iconSuccess from './img/iconSuccess.svg';
import Spinner from './img/Spinner.svg';
import Spinner2 from './img/Spinner2.gif';
import Spinner3 from './img/Spinner3.svg';
import logo26 from './img/logo26.png';
import recurso4 from './img/New_Icons/Recurso 4.svg';
import recurso6 from './img/New_Icons/Recurso 6.svg';
import recurso8 from './img/New_Icons/Recurso 8.svg';
import recurso10 from './img/New_Icons/Recurso 10.svg';
import recurso12 from './img/New_Icons/Recurso 12.svg';
import recurso6green from './img/New_Icons/Recurso 6green.svg';
import recurso17gray from './img/New_Icons/Recurso_17gray.svg';
import settings from './img/New_Icons/Settings.svg';
import logout from './img/New_Icons/log_out.svg';
import iconSwitch from './img/New_Icons/switch.svg';

import campfireSocialLogo from './img/campfire_profile.svg';
import profile3 from './img/profile_example.jpg';
import folder from './img/folder.svg';
import lockopen from './img/lock_open.svg';
import lock from './img/lock.svg';
import search from './img/search.svg';
import notification from './img/notification.svg';
import message from './img/message.svg';
import profile from './img/profile.svg';
import homeIcon from './img/home_icon.svg';
import networkIcon from './img/network_icon.svg';
import providersIcon from './img/providers_icon.svg';
import groupsIcon from './img/groups_icon.svg';
import announcementsIcon from './img/announcements_icon.svg';
// import eventsIcon from './img/network_icon.svg';
import edit from './img/edit.svg';
import dotSeparatorGray from './img/dot_separator_gray.svg';
import openVendorOffers from './img/open_vendor_offers.svg';
import resumeBtn from './img/resume_btn.svg';
import emailBtn from './img/email_btn.svg';
import phoneBtn from './img/phone_btn.svg';
import openVendors from './img/open_vendors.svg';
import pencil from './img/pencil.svg';
import campLogo from './img/camp_logo.svg';
import checkBlack from './img/checkBlack.svg';
import boardOfDirectors from './img/boardOfDirectors.svg';
import logoCampfireSocialColorContent from './img/campfire/Logo_transparent.png';
import logoCampfireSocialColorMobile from './img/campfire/Logo_transparent@2x.png';
import logoCampfireSocialColorHeader from './img/campfire/CampfireSocial_logo_1.0@2x.png';
import logoCampfireSocialColorHeaderMobile from './img/campfire/CampfireSocial_logo_1.0@2x@2x.png';
import editProfilePhoto from './img/edit_profile_photo.svg';
import icoUpload from './img/cards/upload.svg';
import icoTrash from './img/cards/trash.svg';

import phone from './img/phone.svg';
import website from './img/website.svg';
import plus from './img/plus.svg';
import userTest from './img/userTest.png';

// arrows
import arrowUp from './img/arrowUp.svg';
import arrowDown from './img/arrowDown.svg';
import arrowLeft from './img/arrowLeft.svg';
import arrowRight from './img/arrowRight.svg';

import up from './img/up.svg';
import down from './img/down.svg';
import back from './img/back.svg';
import next from './img/next.svg';

import imgx from './img/imgx.svg';
import check from './img/check.svg';

export default {
    iconSwitch,
    logout,
    settings,
    recurso4,
    recurso6,
    recurso6green,
    recurso8,
    recurso10,
    recurso12,
    recurso17gray,
    logo26,
    Spinner,
    Spinner2,
    Spinner3,
    iconSuccess,
    pencilMain,
    web,
    mail,
    settingMain,
    messager2,
    search2,
    userTest,
    plus,
    notUser,
    notUser2,
    campfireSocialLogo,
    phone,
    search,
    notification,
    message,
    profile,
    homeIcon,
    networkIcon,
    providersIcon,
    groupsIcon,
    announcementsIcon,
    // eventsIcon,
    edit,
    dotSeparatorGray,
    openVendorOffers,
    resumeBtn,
    emailBtn,
    phoneBtn,
    openVendors,
    pencil,
    campLogo,
    logoCampfireSocialColorContent,
    logoCampfireSocialColorMobile,
    logoCampfireSocialColorHeader,
    logoCampfireSocialColorHeaderMobile,
    lock,
    folder,
    lockopen,
    editProfilePhoto,
    icoUpload,
    icoTrash,
    profile3,
    boardOfDirectors,
    checkBlack,
    arrowUp,
    arrowDown,
    arrowLeft,
    arrowRight,
    up,
    down,
    back,
    imgx,
    check,
    next,
    website
};
